import React, { useState, useEffect, useRef } from "react";
import OrderFooterButtonsComponent from "./OrderFooterButtonsComponent";
import PaymentOrderItemsSummary from "../../payment/PaymentOrderItemsSummary";
import PaymentOrderItemRow from "../../payment/PaymentOrderItemRow";
import PaymentOrderItemRowSplitted from "../../payment/PaymentOrderItemRowSplitted";

export default function OrderPaymentItemsComponent({
  context,
  orderStatus = "",
  summary,
  foods,
  onUpdateFoodSelection,
}) {
  const onHanleButtonActions = () => {};

  return (
    <div className="flex-1 bg-green-100 rounded shadow flex flex-col">
      <div className="flex-1 flex flex-col">
        <div className="flex justify-between font-bold pb-2 border-b border-gray-200 px-5">
          <div>Items</div>
          <div>Amount</div>
        </div>
        <div className="flex-1 max-h-[350px] overflow-y-scroll mt-2 space-y-1 pr-1 pl-5">
          {foods.map((item, indx) => (
            <div key={`${item.id}-${indx}`}>
              {context === "SPLIT_BILL" ? (
                <PaymentOrderItemRowSplitted item={item} onUpdateFoodSelection={onUpdateFoodSelection} />
              ) : (
                <PaymentOrderItemRow item={item} />
              )}
            </div>
          ))}
        </div>
      </div>
      <PaymentOrderItemsSummary summary={summary} />
      <div>
        <OrderFooterButtonsComponent onHanleButtonActions={onHanleButtonActions} orderStatus={orderStatus} />
      </div>
    </div>
  );
}
